import Vue from 'vue';
import VueRouter from 'vue-router';

import i18n from '@/i18n';
import Home from '@/views/Home.vue';
import Members from '@/views/Members.vue';
import MemberDetail from '@/views/MemberDetail.vue';
import Publications from '@/views/Publications.vue';
import PublicationDetail from '@/views/PublicationDetail.vue';
import Teaching from '@/views/Teaching.vue';
import Opening from '@/views/Opening.vue';
import NotFound from '@/views/NotFound.vue';


Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      titleKey: 'router.home.title',
    },
  },
  {
    path: '/members',
    name: 'Members',
    component: Members,
    meta: {
      titleKey: 'router.members.title',
    },
  },
  {
    path: '/members/:slug',
    name: 'MemberDetail',
    component: MemberDetail,
    meta: {
      titleKey: 'router.members.title',
    },
  },
  {
    path: '/publications',
    name: 'Publications',
    component: Publications,
    meta: {
      titleKey: 'router.publications.title',
    },
  },
  {
    path: '/publications/:id',
    name: 'PublicationDetail',
    component: PublicationDetail,
    meta: {
      titleKey: 'router.publications.title',
    },
  },
  {
    path: '/teaching',
    name: 'Teaching',
    component: Teaching,
    meta: {
      titleKey: 'router.teaching.title',
    },
  },
  {
    path: '/opening',
    name: 'Opening',
    component: Opening,
    meta: {
      titleKey: 'router.opening.title',
    },
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
    meta: {
      titleKey: 'router.notFound.title',
    },
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // wait for the out transition to complete (if any)
    return new Promise((resolve) => {
      setTimeout(() => {
        if (savedPosition) {
          return resolve(savedPosition);
        }
        if (to.hash) {
          return resolve({ selector: to.hash, behavior: 'smooth' });
        }
        return resolve({ x: 0, y: 0 });
      }, 300);
    });
  },
});

function resolveMetaText(path) {
  if (!path) {
    return '';
  }

  if (typeof path === 'string' && i18n.te(path)) {
    return i18n.t(path);
  }

  return path;
}

export function updateDocumentTitle(route = router.currentRoute) {
  const siteShort = resolveMetaText('meta.siteShort') || resolveMetaText('meta.siteName');
  const routeTitle = resolveMetaText(route?.meta?.titleKey) || siteShort;

  if (routeTitle && siteShort) {
    document.title = `${routeTitle} | ${siteShort}`;
  } else if (routeTitle) {
    document.title = routeTitle;
  } else {
    document.title = siteShort || document.title;
  }
}

router.beforeEach((to, from, next) => {

  next();
});

router.afterEach((to) => {
  updateDocumentTitle(to);
});

export default router;
